module.exports = __webpack_public_path__ + "static/img/msg-bg-0.24a9bce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpn/msg-bg-0.png
// module id = JtJM
// module chunks = 1